import {asyncActionGenerator} from 'utils/actionCreator';

export const createSessionAsyncActions = asyncActionGenerator('CREATE_VIDEO_SESSION')
export const videoEndedAsyncActions = asyncActionGenerator('EMBED_VIDEO_ENDED')
export const endTimeUpdateAsyncActions = asyncActionGenerator('EMBED_END_TIME_UPDATE')